<template>
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      :permission="permissionList"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button type="primary" icon="el-icon-plus" size="small" @click="openApplyDialog('add')">
          新建申领
        </el-button>
        <el-button
          type="primary"
          plain
          icon="el-icon-download"
          size="small"
          :loading="exportLoading"
          @click="handleExport"
        >
          导出
        </el-button>
      </template>

      <template slot="sourceType" slot-scope="{ row }">
        {{ formatSourceType(row.sourceType) }}
      </template>

      <template slot="status" slot-scope="{ row }">
        <el-tag :type="getStatusType(row.status)" size="small">
          {{ getStatusLabel(row.status) }}
        </el-tag>
      </template>

      <template slot="menu" slot-scope="{ row }">
        <template v-if="row.status === 0">
          <el-button v-if="row.canEdit" type="text" size="small" style="color: #409eff" @click="openApplyDialog('edit', row)">
            修改
          </el-button>
          <el-button type="text" size="small" style="color: #67c23a" @click="handleApprove(row)">
            同意
          </el-button>
          <el-button type="text" size="small" style="color: #f56c6c" @click="handleReject(row)">
            拒绝
          </el-button>
          <el-button type="text" size="small" style="color: #909399" @click="openApplyDialog('view', row)">
            详情
          </el-button>
          <el-button type="text" size="small" @click="openFlowDialog(row)">
            流程
          </el-button>
        </template>

        <template v-else-if="row.status === 1">
          <el-button v-if="row.canConfirmReceive" type="text" size="small" style="color: #67c23a" @click="handleConfirmReceive(row)">
            确认领用
          </el-button>
          <el-button type="text" size="small" @click="openApplyDialog('view', row)">
            详情
          </el-button>
          <el-button type="text" size="small" @click="openFlowDialog(row)">
            流程
          </el-button>
        </template>

        <template v-else-if="row.status === 2">
          <el-button type="text" size="small" style="color: #e6a23c" @click="handleConfirmReturn(row)">
            确认完成
          </el-button>
          <el-button type="text" size="small" @click="openApplyDialog('view', row)">
            详情
          </el-button>
          <el-button type="text" size="small" @click="openFlowDialog(row)">
            流程
          </el-button>
        </template>

        <template v-else>
          <el-button type="text" size="small" @click="openApplyDialog('view', row)">
            详情
          </el-button>
          <el-button type="text" size="small" @click="openFlowDialog(row)">
            流程
          </el-button>
        </template>
      </template>
    </avue-crud>

    <!-- 申领表单弹窗 -->
    <part-apply-form-dialog ref="applyFormDlg" @success="handleApplySuccess" />

    <!-- 拒绝原因弹窗 -->
    <el-dialog
      title="拒绝原因"
      :visible.sync="rejectVisible"
      width="400px"
      append-to-body
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :z-index="3010"
    >
      <el-input
        v-model="rejectRemark"
        type="textarea"
        :rows="3"
        placeholder="请输入拒绝原因"
        maxlength="200"
        show-word-limit
      />
      <span slot="footer">
        <el-button @click="rejectVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmReject">确定</el-button>
      </span>
    </el-dialog>

    <!-- 确认归还弹窗 -->
    <el-dialog
      title="领用确认完成"
      :visible.sync="returnVisible"
      width="860px"
      append-to-body
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :z-index="3010"
    >
      <el-alert
        title="填写实际使用数量，归还数量会回冲库存；全部用完时归还数量填 0。"
        type="info"
        :closable="false"
        show-icon
        style="margin-bottom: 12px"
      />
      <el-table :data="returnForm.detailList" border size="small" style="width: 100%">
        <el-table-column type="index" label="序号" width="50" align="center" />
        <el-table-column prop="partCode" label="编码" min-width="110" show-overflow-tooltip />
        <el-table-column prop="partName" label="名称" min-width="140" show-overflow-tooltip />
        <el-table-column prop="specification" label="规格" min-width="100" show-overflow-tooltip />
        <el-table-column prop="requestQty" label="领用数量" width="90" align="center" />
        <el-table-column label="实际使用数量" width="150" align="center">
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.actualUseQty"
              :min="0"
              :max="Number(scope.row.requestQty) || 0"
              :precision="0"
              :step="1"
              controls-position="right"
              size="mini"
              style="width: 120px"
              @change="onActualUseChange(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column label="归还数量" width="140" align="center">
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.returnQty"
              :min="0"
              :max="Number(scope.row.requestQty) || 0"
              :precision="0"
              :step="1"
              controls-position="right"
              size="mini"
              style="width: 110px"
              @change="onReturnQtyChange(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column label="备注" min-width="140">
          <template slot-scope="scope">
            <el-input v-model="scope.row.remark" maxlength="256" size="mini" />
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button @click="returnVisible = false">取消</el-button>
        <el-button type="primary" :loading="returnSubmitting" @click="submitConfirmReturn">
          确认完成
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="审批流程"
      :visible.sync="flowVisible"
      width="760px"
      append-to-body
      :close-on-click-modal="false"
      :z-index="3010"
    >
      <el-steps :active="flowActiveIndex" finish-status="success" align-center>
        <el-step
          v-for="item in flowSteps"
          :key="item.key"
          :title="item.title"
          :description="item.description"
          :status="item.status"
        />
      </el-steps>
      <el-table
        v-if="flowRecords.length"
        :data="flowRecords"
        border
        size="small"
        style="width: 100%; margin-top: 18px"
      >
        <el-table-column prop="nodeSort" label="级次" width="70" align="center" />
        <el-table-column prop="nodeName" label="节点" min-width="120" />
        <el-table-column prop="approvalDeptName" label="审批部门" min-width="140" />
        <el-table-column label="结果" width="90" align="center">
          <template slot-scope="scope">{{ formatAuditResult(scope.row.auditResult) }}</template>
        </el-table-column>
        <el-table-column prop="auditUserName" label="处理人" min-width="100" />
        <el-table-column prop="auditTime" label="处理时间" min-width="150" />
        <el-table-column prop="auditRemark" label="意见" min-width="140" show-overflow-tooltip />
      </el-table>
      <span slot="footer">
        <el-button type="primary" @click="flowVisible = false">关闭</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { initDataTime, numSeparator } from '@/basic-common/util/common'
import { desensitizationDispose } from '@/basic-common/util/desensitization'
import crudMixins from '@/mixins/crud-mixins'
import {
  getList,
  getById,
  approve,
  reject,
  confirmReceive,
  confirmReturn,
  exportExcel,
} from './api'
import { downloadXls } from '@/util/util'
import PartApplyFormDialog from './components/PartApplyFormDialog.vue'

export default {
  name: 'part-request-apply',
  components: {
    PartApplyFormDialog,
  },
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: { getList },
      rejectVisible: false,
      rejectRemark: '',
      returnVisible: false,
      returnSubmitting: false,
      exportLoading: false,
      flowVisible: false,
      flowRecords: [],
      flowRow: null,
      returnForm: {
        id: null,
        requestNo: '',
        detailList: [],
      },
      currentRow: null,
      option: {
        ...this.$store.state.publicOption,
        menu: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewBtn: false,
        menuWidth: 280,
        column: [
          {
            label: '申领单号',
            prop: 'requestNo',
            minWidth: 150,
            search: true,
          },
          {
            label: '设备',
            prop: 'deviceName',
            minWidth: 140,
            overHidden: true,
          },
          {
            label: '来源',
            prop: 'sourceType',
            minWidth: 100,
            slot: true,
            search: true,
            type: 'select',
            dataType: 'number',
            dicData: [
              { label: '维修工单', value: 1 },
              { label: '设备维保', value: 2 },
            ],
          },
          {
            label: '申领原因',
            prop: 'applyReason',
            minWidth: 160,
            overHidden: true,
          },
          {
            label: '种类数',
            prop: 'partKindCount',
            width: 80,
            align: 'center',
          },
          {
            label: '总数量',
            prop: 'totalRequestQty',
            width: 100,
            align: 'center',
          },
          {
            label: '申请人',
            prop: 'applicantName',
            minWidth: 100,
          },
          {
            label: '当前节点',
            prop: 'currentNodeName',
            minWidth: 120,
            overHidden: true,
          },
          {
            label: '审批截止',
            prop: 'approvalDeadlineTime',
            minWidth: 160,
            formatter: (row, value) => this.formatDateTime(value),
          },
          {
            label: '库房部门',
            prop: 'warehouseDeptName',
            minWidth: 120,
            overHidden: true,
          },
          {
            label: '申请时间',
            prop: 'requestTime',
            minWidth: 160,
            formatter: (row, value) => this.formatDateTime(value),
          },
          {
            label: '状态',
            prop: 'status',
            minWidth: 100,
            slot: true,
            search: true,
            type: 'select',
            dataType: 'number',
            dicData: [
              { label: '待审批', value: 0 },
              { label: '待确认领用', value: 1 },
              { label: '待确认完成', value: 2 },
              { label: '已完成', value: 3 },
              { label: '已拒绝', value: 4 },
            ],
          },
        ],
      },
    }
  },
  computed: {
    flowSteps() {
      const records = this.flowRecords || []
      const row = this.flowRow || {}
      const steps = [{ key: 'submit', title: '提交申请', description: row.applicantName || '', status: 'success' }]
      records.forEach((record) => {
        let status = 'wait'
        if (record.auditResult === 1) status = 'success'
        if (record.auditResult === 2) status = 'error'
        if (row.status === 0 && row.currentNodeSort === record.nodeSort) status = 'process'
        steps.push({
          key: `audit-${record.nodeSort}`,
          title: record.nodeName || `第${record.nodeSort}级审批`,
          description: record.approvalDeptName || '',
          status,
        })
      })
      steps.push({
        key: 'receive',
        title: '确认领用',
        description: row.warehouseDeptName || '',
        status: row.status === 1 ? 'process' : row.status > 1 && row.status !== 4 ? 'success' : 'wait',
      })
      steps.push({
        key: 'complete',
        title: '确认完成',
        description: row.warehouseDeptName || '',
        status: row.status === 2 ? 'process' : row.status === 3 ? 'success' : row.status === 4 ? 'error' : 'wait',
      })
      return steps
    },
    flowActiveIndex() {
      const idx = this.flowSteps.findIndex((item) => item.status === 'process')
      return idx >= 0 ? idx : this.flowSteps.filter((item) => item.status === 'success').length
    },
  },
  methods: {
    handleApplySuccess() {
      this.onLoad(this.page, this.query)
    },
    async handleExport() {
      this.exportLoading = true
      try {
        const params = this.formatParams(Object.assign({}, this.defaultParams, this.query))
        const res = await exportExcel(params)
        downloadXls(res.data, `备件领用记录_${Date.now()}.xlsx`)
        this.$message.success('导出成功')
      } catch (e) {
        console.warn(e)
        this.$message.error((e && e.message) || '导出失败')
      } finally {
        this.exportLoading = false
      }
    },

    /**
     * 覆盖 crud-mixins：
     * 列表脱敏若包含 id 等字段名，会改写 row.id，导致审批请求 id 错误。
     * 主键与外键不参与脱敏（与接口返回一致）。
     */
    onLoad(page, params = {}) {
      if (this.initstate) {
        this.initstate = false
        return
      }
      this.queryData = this.formatParams(Object.assign({}, this.defaultParams, params, this.query))
      if (!this.apiConfig || !this.apiConfig.getList) return
      this.loading = true
      const requestParams = {
        ...this.queryData,
        page: page.currentPage,
        size: page.pageSize,
      }
      this.apiConfig.getList(requestParams).then((res) => {
        this.responseData = res.data.data.records
        this.page.total = res.data.data.total
        this.responseData = initDataTime(this.responseData, this.option.column)
        this.data = numSeparator(this.responseData, this.option, 'list')
        const preserveKeys = [
          'id',
          'deviceId',
          'applicantId',
          'warehouseDeptId',
          'approverId',
          'createUser',
          'createDept',
          'updateUser',
        ]
        this.data = desensitizationDispose(this.responseData, 'list', preserveKeys)
        if (this.initCardData) {
          this.initCardData()
        } else {
          this.cardData = res.data.data
        }
        if (this.afterSearch) this.afterSearch()
      }).finally(() => {
        this.loading = false
      })
    },

    formatDateTime(value) {
      if (!value) return '-'
      if (typeof value === 'number') {
        const date = new Date(value)
        const y = date.getFullYear()
        const m = String(date.getMonth() + 1).padStart(2, '0')
        const d = String(date.getDate()).padStart(2, '0')
        const h = String(date.getHours()).padStart(2, '0')
        const min = String(date.getMinutes()).padStart(2, '0')
        const s = String(date.getSeconds()).padStart(2, '0')
        return `${y}-${m}-${d} ${h}:${min}:${s}`
      }
      return value
    },

    formatSourceType(v) {
      const m = { 1: '维修工单', 2: '设备维保' }
      return m[v] != null ? m[v] : '-'
    },

    getStatusType(status) {
      const map = { 0: 'warning', 1: 'primary', 2: 'warning', 3: 'success', 4: 'danger' }
      return map[status] || 'info'
    },

    getStatusLabel(status) {
      const map = {
        0: '待审批',
        1: '待确认领用',
        2: '待确认完成',
        3: '已完成',
        4: '已拒绝',
      }
      return map[status] != null ? map[status] : '-'
    },

    formatAuditResult(result) {
      const map = { 0: '待处理', 1: '通过', 2: '拒绝' }
      return map[result] || '-'
    },

    openApplyDialog(mode, row) {
      if (mode === 'add') {
        this.$refs.applyFormDlg.open({ mode: 'add', deviceLocked: false })
        return
      }
      this.$refs.applyFormDlg.open({ mode, row })
    },

    async openFlowDialog(row) {
      try {
        const res = await getById(row.id)
        const dto = res && res.data && res.data.data
        this.flowRow = dto || row
        this.flowRecords = (dto && dto.auditRecordList) || []
        this.flowVisible = true
      } catch (e) {
        this.$message.error('加载审批流程失败')
      }
    },

    async handleConfirmReceive(row) {
      try {
        await this.$confirm(
          '确认该申领已领用？确认后将按照明细扣减库存。',
          '提示',
          { type: 'warning' }
        )
        const res = await confirmReceive(row.id, '库房确认领用')
        const body = res && res.data
        if (body && body.success && (body.code === 200 || body.code === 2000)) {
          this.$message.success('确认领用成功，库存已扣减')
          this.onLoad(this.page, this.query)
        } else {
          this.$message.error((body && body.msg) || '操作失败')
        }
      } catch (e) {
        if (e === 'cancel') return
        if (!e || !e.message) {
          this.$message.error('操作失败')
        }
      }
    },

    async handleConfirmReturn(row) {
      try {
        const res = await getById(row.id)
        const body = res && res.data
        const dto = body && body.data
        if (!dto || !dto.id) {
          this.$message.error('加载申请明细失败')
          return
        }
        this.returnForm = {
          id: dto.id,
          requestNo: dto.requestNo || '',
          detailList: (dto.detailList || []).map((d) => {
            const requestQty = Number(d.requestQty) || 0
            const actualUseQty = d.actualUseQty != null ? Number(d.actualUseQty) : requestQty
            const returnQty = d.returnQty != null
              ? Number(d.returnQty)
              : Math.max(requestQty - actualUseQty, 0)
            return {
              id: d.id,
              partCode: d.partCode,
              partName: d.partName,
              specification: d.specification,
              requestQty,
              actualUseQty,
              returnQty,
              remark: d.remark || '',
            }
          }),
        }
        this.returnVisible = true
      } catch (e) {
        this.$message.error('加载申请明细失败')
      }
    },

    onActualUseChange(row) {
      const requestQty = Number(row.requestQty) || 0
      const actualUseQty = Number(row.actualUseQty) || 0
      row.returnQty = Math.max(requestQty - actualUseQty, 0)
    },

    onReturnQtyChange(row) {
      const requestQty = Number(row.requestQty) || 0
      const returnQty = Number(row.returnQty) || 0
      row.actualUseQty = Math.max(requestQty - returnQty, 0)
    },

    async submitConfirmReturn() {
      const detailList = this.returnForm.detailList || []
      if (!detailList.length) {
        this.$message.warning('缺少申请明细')
        return
      }
      for (let i = 0; i < detailList.length; i++) {
        const line = detailList[i]
        const requestQty = Number(line.requestQty) || 0
        const actualUseQty = Number(line.actualUseQty)
        const returnQty = Number(line.returnQty)
        if (
          !Number.isFinite(actualUseQty) ||
          !Number.isFinite(returnQty) ||
          actualUseQty < 0 ||
          returnQty < 0
        ) {
          this.$message.warning(`第 ${i + 1} 行数量填写不正确`)
          return
        }
        if (Math.abs(actualUseQty + returnQty - requestQty) > 0.000001) {
          this.$message.warning(`第 ${i + 1} 行实际使用数量 + 归还数量必须等于领用数量`)
          return
        }
      }

      this.returnSubmitting = true
      try {
        const res = await confirmReturn({
          id: this.returnForm.id,
          detailList: detailList.map((d) => ({
            id: d.id,
            actualUseQty: d.actualUseQty,
            returnQty: d.returnQty,
            remark: d.remark,
          })),
        })
        const body = res && res.data
        if (body && body.success && (body.code === 200 || body.code === 2000)) {
          this.$message.success('已确认完成')
          this.returnVisible = false
          this.onLoad(this.page, this.query)
        } else {
          this.$message.error((body && body.msg) || '操作失败')
        }
      } catch (e) {
        if (!e || !e.message) {
          this.$message.error('操作失败')
        }
      } finally {
        this.returnSubmitting = false
      }
    },

    async handleApprove(row) {
      try {
        await this.$confirm(
          '确认同意该申领？同意后将按照明细扣减库存。',
          '提示',
          { type: 'warning' }
        )
        const res = await approve(row.id)
        const body = res && res.data
        if (body && body.success && (body.code === 200 || body.code === 2000)) {
          this.$message.success('同意成功，库存已扣减')
          this.onLoad(this.page, this.query)
        } else {
          this.$message.error((body && body.msg) || '操作失败')
        }
      } catch (e) {
        if (e === 'cancel') return
        if (!e || !e.message) {
          this.$message.error('操作失败')
        }
      }
    },

    handleReject(row) {
      this.currentRow = row
      this.rejectRemark = ''
      this.rejectVisible = true
    },

    async confirmReject() {
      if (!this.rejectRemark) {
        this.$message.warning('请输入拒绝原因')
        return
      }
      try {
        const res = await reject(this.currentRow.id, null, null, this.rejectRemark)
        const body = res && res.data
        if (body && body.success && (body.code === 200 || body.code === 2000)) {
          this.$message.success('已拒绝申领')
          this.rejectVisible = false
          this.onLoad(this.page, this.query)
        } else {
          this.$message.error((body && body.msg) || '操作失败')
        }
      } catch (error) {
        if (!error || !error.message) {
          this.$message.error('操作失败')
        }
      }
    },
  },
}
</script>
